import * as React from 'react'

import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

import logo from '../../../logo.png';
import * as theme from '../../../theme'
import { CircularProgress } from '@mui/material';

const CustomizeButton = styled(Button)({
  fontSize: 16,
  padding: '1px 20px',
  border: '1px solid',
  lineHeight: 1.5,
  width: '100%',
  color: theme.MAIN_BUTTON_FONT,
  backgroundColor: theme.MAIN_BUTTON,
  borderColor: theme.MAIN_BUTTON,
  borderRadius:10,
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: theme.PRIMARY_BUTTON,
    borderColor: theme.PRIMARY_BUTTON,
    color: theme.PRIMARY_BUTTON_FONT
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: theme.MAIN_BUTTON,
    borderColor: theme.MAIN_BUTTON,
  },
  '&:disabled': {
    boxShadow: 'none',
    backgroundColor: theme.MAIN_BUTTON,
    borderColor: theme.MAIN_BUTTON,
  }
})



export default function MainButton(props) {
  const {buttonText, loading=true, ...rest }  = props
  return (
      <CustomizeButton variant="contained" disabled={loading} {...rest}>
        {
        loading?
        <CircularProgress sx={{ color: theme.BODY_BG,}} />:
        <>
          <img src={logo} alt="Logo" width={50}  /> 
          {buttonText}
        </>
        }
         
      </CustomizeButton>
  )
}